import React, { useState } from 'react';
import styles from './FaqComponent.module.css';
import draft from '../../Images/DriftFeatures.png';

const faqData = [
  {
    question: "Does ToxBox support group video calls?",
    answer: "Yes, ToxBox supports group video calls with multiple participants.",
  },
  {
    question: "What kind of analytics does it provide?",
    answer: "ToxBox provides call metrics, user insights, and engagement analytics.",
  },
  {
    question: "Is the AI voice customizable?",
    answer: "Yes, you can choose from different voice profiles and accents.",
  },
  {
    question: "How secure is ToxBox",
    answer: "It uses end-to-end encryption and secure protocols for all communication.",
  },
  {
    question: "How much does ToxBox cost",
    answer: "Pricing varies based on your plan—check our pricing page for details.",
  },
  {
    question: "Is real-time call monitoring available?",
    answer: "Yes, admins can listen in on live calls, see call status and intervene if needed.",
  },
];

const FaqComponent = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 6;

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentFaqs = faqData.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(faqData.length / itemsPerPage);

  const goToNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const goToPrevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  return (
    <section className={styles.faqSection}>
      <div className={styles.header}>
        <h2>
          Frequently Asked <span className={styles.highlight}>Questions</span>
        </h2>
        <p>
          We value your time. That’s why we've compiled straightforward answers to frequently asked
          questions — so you can get informed, stay on track, and make the most of your experience with us.
        </p>
        <svg viewBox="0 0 1440 290" preserveAspectRatio="none">
          <path
            fill="#f3efff"
            d="M0,288L48,272C96,256,192,224,288,197.3C384,171,480,149,576,133.3C672,117,768,107,864,128C960,149,1056,203,1152,208C1248,213,1344,171,1392,149.3L1440,128L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
          ></path>
        </svg>
      </div>

      <div className={styles.content}>
        <div className={styles.left}>
          {currentFaqs.map((item, index) => {
            const actualIndex = index + indexOfFirstItem;
            return (
              <div key={actualIndex} className={styles.faqItem}>
                <button onClick={() => toggleFAQ(actualIndex)} className={styles.faqButton}>
                  {item.question}
                  <span className={styles.toggleIcon}>
                    {activeIndex === actualIndex ? '−' : '+'}
                  </span>
                </button>
                {activeIndex === actualIndex && (
                  <p className={styles.answer}>{item.answer}</p>
                )}
              </div>
            );
          })}

          <div className={styles.pagination}>
            <button onClick={goToPrevPage} disabled={currentPage === 1}>
              Prev
            </button>
            <span>
              Page {currentPage} of {totalPages}
            </span>
            <button onClick={goToNextPage} disabled={currentPage === totalPages}>
              Next
            </button>
          </div>
        </div>

        <div className={styles.right}>
          <h3>Any Questions?</h3>
          <img
            src={draft}
            alt="chat illustration"
            className={styles.image}
          />
          <label htmlFor="user-question">Let me know?</label>
          <input id="user-question" type="text" className={styles.input} />
          <button className={styles.sendButton}>Sent</button>
        </div>
      </div>
    </section>
  );
};

export default FaqComponent;
